<template>
  <div>
    <b-row
      ><b-col> <h3>View Address</h3></b-col>
      <!-- <b-col>
        <b-button
          style="float: right"
          variant="outline-primary"
          @click="$router.push({ name: 'address-create' })"
          >Add New Address</b-button
        >
      </b-col> -->
    </b-row>

    <b-row>
      <b-col md="4" v-for="(item, i) in address" :key="i">
        <div class="addressNo">
          <b-row
            ><b-col
              ><h4
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <span class="text-info"> Customer Name : </span>
                <span>{{ item.fullName }}</span>
              </h4></b-col
            ><b-col>
              <b-button
                v-if="item.isDefault"
                variant="outline-primary"
                style="float: right; border-radius: 16px"
                >Default</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-n3"
            ><b-col>
              <h5 style="text-overflow: ellipsis">
                <span class="text-info">Delivery Address : </span>
                <span class="text-black">
                  {{ item.street1 }},{{ item.street2 }}, <br />
                  {{ item.city }}, {{ item.state }},<br />
                  {{ item.country }},
                  {{ item.zip }}
                </span>
              </h5>
            </b-col>
          </b-row>
          <b-row class="mt-n3" v-for="(phone, k) in item.contacts" :key="k"
            ><b-col
              ><h5
                v-if="phone.contactType === 'PRIMARY_PHONE'"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <span class="text-info">Customer Phone : </span>
                <span>{{ phone.value }}</span>
              </h5></b-col
            >
            <!-- <b-col>
              <b-button
                variant="primary"
                style="float: right; border-radius: 16px"
                >Edit</b-button
              ></b-col
            > -->
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import addressCreateVue from "./addressCreate.vue";
// import { mapGetters } from "vuex";
export default {
  // components: { addressCreateVue },
  data() {
    return {
      currentUser: "",
      address: "",
    };
  },

  computed: {
    // ...mapGetters({
    //   addAddress: "customerManagement/GetAddressList",
    // }),
  },

  methods: {
    // createAddress() {
    //   this.$router.push({
    //     path: "/createAddress",
    //     name: "address-create",
    //   });
    // },
    async fetchAddressData() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/customerDetails",
        payload
      );
      return (this.address = data ? data.addresses : "");
    },
  },
  async mounted() {
    this.currentUser = this.$route.params;
    await this.fetchAddressData();
  },
};
</script>

<style>
.btn-secondary {
  border-radius: 50%;
  background-color: #42b039;
  border-color: #42b039;
  height: 44px;
  color: #fff;
}
.btn-secondary.btn-secondary:hover {
  color: #fff;
  background-color: #62c45a;
  border-color: #62c45a;
}
.addressNo {
  border: 1px solid #efefef;
  box-shadow: 0px 0px 6px 0px #ddd;
  border-radius: 10px;
  padding: 14px;
  width: 320px;
  height: 170px;
}
</style>
